// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React, {useContext} from 'react';
import {useHistory} from 'react-router';
import cn from 'classnames';
import {Settings_context} from '../../../../hola/pub/settings_ctx';
import {Flag} from '../../../../hola/pub/lib/flag';
import country from '/util/country.js';
import {bd_countries} from 'hola_opt';
import {use_translation_v} from '../../../../hola/pub/lib/trans_v';
import styles from './top_locations.module.less';

interface i_top_locations_props {
    country?: string;
}
const landing_flags = [
    {country: 'br', title: 'Brazil'},
    {country: 'gb', title: 'United Kingdom'},
    {country: 'de', title: 'Germany'},
    {country: 'fr', title: 'France'},
    {country: 'ca', title: 'Canada'},
    {country: 'us', title: 'United States'},
    {country: 'jp', title: 'Japan'},
    {country: 'au', title: 'Australia'},
];
const get_region_countries = (region: string)=>{
    const excluded_countries = ['ps'];
    const countries = bd_countries.by_region[region]?.countries || [];
    return countries.filter(ctr=>!excluded_countries.includes(ctr));
};
const get_flag_country_code = (country_code: string)=>{
    const french_territories = {
        'gp': 'fr', // Guadeloupe
        'bl': 'fr', // Saint Barthelemy
        'mf': 'fr', // Saint Martin
        're': 'fr', // Réunion
        'yt': 'fr', // Mayotte
        'wf': 'fr', // Wallis And Futuna Islands
    };
    return french_territories[country_code?.toLowerCase()] || country_code;
};
export const prepare_continent_data = ()=>{
    return country.continents.map(continent=>{
        const continent_name = continent.replace(/-/g, ' ');
        const {key} = country.get_continent_adjective_form(continent_name);
        return {
            quest: continent_name.replace(/\b\w/g, l=>l.toUpperCase()),
            ans: get_region_countries(key)
                .map(country_code=>{
                    const country_name =
                        country.list[country_code.toUpperCase()];
                    return {
                        name: country_name,
                        url: `/proxy-location/${country_name.toLowerCase()
                            .replace(/\s+/g, '-')}`
                    };
                })
        };
    });
};
export const Top_locations = (props: i_top_locations_props)=>{
    const {country: location_name} = props;
    const {theme} = useContext(Settings_context);
    const {T} = use_translation_v({no_defaults: true});
    const history = useHistory();
    const location_info = React.useMemo(()=>{
        return country.get_location_info(location_name);
    }, [location_name]);
    const is_continent_page = location_info?.type === 'continent';
    const show_landing_flags = !is_continent_page;
    const get_continent_key = (continent_name: string)=>{
        const continent_mapping = {
            'europe': 'Europe',
            'north america': 'Northern America',
            'latin america': 'South America',
            'asia': 'Asia',
            'africa': 'Africa',
            'oceania': 'Oceania'
        };
        const normalized = continent_name?.toLowerCase().replace(/-/g, ' ');
        return continent_mapping[normalized] ||
            continent_name.replace(/\b\w/g, c=>c.toUpperCase());
    };
    const location_title = is_continent_page
        ? `${location_info.name?.replace(/-/g, ' ')
        .replace(/\b\w/g, l=>l.toUpperCase())} proxy locations`
        : 'Most Popular Proxy Locations';
    const get_country_url = (_title: string)=>{
        let country_param = _title.toLowerCase().replace(' ', '-');
        if (_title == 'United Kingdom')
            country_param = 'great-britain';
        history.push(`/proxy-location/${country_param}`);
        window.scrollTo({top: 0, behavior: 'smooth'});
    };
    const location_countries = show_landing_flags
        ? landing_flags
        : get_region_countries(get_continent_key(location_info.name || ''));
    return <div className={styles.top_locations}>
      <div className={styles.locations_text}>
        <h2 className={theme.color_n700}><T>{location_title}</T></h2>
        <div className={styles.flags}>
          {location_countries.map(f=>{
            const _country_code = show_landing_flags ? f.country :
              is_continent_page ? f : f.country;
            const country_name = show_landing_flags ? f.title :
              is_continent_page ? country.list[_country_code.toUpperCase()]
              : f.title;
            const flag_code = get_flag_country_code(_country_code);
            return <div
              key={is_continent_page ? f : f.country}
              className={styles.country_ip}
              onClick={e=>{
                e.preventDefault();
                get_country_url(country_name);
              }}>
              <div className={styles.line_with_flag}>
                <Flag
                  round
                  country={flag_code}
                  size={18}
                />
                <p className={cn(
                  theme.p3,
                  theme.color_n800,
                  theme.med,
                  styles.country_name
                )}>
                  {country_name}
                </p>
              </div>
            </div>;
          })}
        </div>
      </div>
    </div>;
};
